import { BaseModel } from '../base.model';

export interface SendOutGoods extends BaseModel {
    shipmentLine?: any;
}

export const defaultSendOutGoods: Readonly<SendOutGoods> = {};